import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getCards, type CardsParams } from 'services/CardService'

export const useCardsQuery = (params: CardsParams, isEnabled = true) => {
  return useQuery({
    queryKey: reactQueryKeys.cards(params.q, params.pageNumber ?? 0, params.pageSize ?? 50),
    queryFn: () => getCards(params),
    enabled: isEnabled,
  })
}
